import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import AssignCarsOrGroupsDialog from "../../Common/AssignCarsOrGroupsDialog";
import ReportDetails from './ReportDetails';
import EmailsDialog from "./EmailsDialog";
import t from "../../../languages/pl";
import moment from "moment";

const initialState = {
    cykl: 0,
    email: [],
    nazwa: "",
    nazwa_pliku: "",
    raport_id: 0,
    typ: "",
    typ_id: 0,
    warunki: "",
    startTime: moment().startOf('week').unix(),
    endTime: moment().unix(),
    isAutomatic: false,
    wybor: 1,
    wybor_dane: 13853,
};

const ReportDetailsWithCars = props => {
    const { title, open, onClose, onSubmit, autoEnable = false, isEdit = false, report, isNew, typeId, fileId } = props;
    const [state, setState] = useState(initialState);
    const [emailsOpen, setEmailsOpen] = useState(false);
    const [checkedOption, setCheckedOption] = useState(1);
    const [carList, setCarList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [dataToSend, setDataToSend] = useState(null);
    const [conditions, setConditions] = useState(null);

    const dialogTitle = t.toReport + " " + title;


    useEffect(() => {
        if (report) {
            setState(report);
            if (isEdit) {
                setCheckedOption(report.wybor);
                if (report.wybor === 1) {
                    setCarList(report.wybor_dane);
                }
                if (report.wybor === 2) {
                    setGroupList(report.wybor_dane);
                }
                if(report.warunki){
                    setConditions(report.warunki);
                }
            }
        }
    }, [report]);

    useEffect(() => {
        if (typeId) {
            setState({
                ...state,
                typ_id: typeId
            });
        }
    }, [typeId]);

    useEffect(() => {
    }, [fileId]);

    const handleSubmit = (carIds) => {
        if (!isEdit) {
            setDataToSend({
                nazwa: state.nazwa ? state.nazwa : "",
                nazwapliku: state.nazwa_pliku ? state.nazwa_pliku : "",
                typ_id: typeId,
                cykl: state.isAutomatic ? state.cykl : null,
                data_od: state.isAutomatic ? null : state.startTime,
                data_do: state.isAutomatic ? null : state.endTime,
                wybor: checkedOption,
                wybor_dane: checkedOption === 3 ? null : carIds,
                warunki: conditions ? conditions : null,
                plik_id: fileId
            });
            setEmailsOpen(true);
        }
        else {
            onSubmit && onSubmit({
                nazwa: state.nazwa ? state.nazwa : "",
                nazwapliku: state.nazwa_pliku ? state.nazwa_pliku : "",
                raport_id: state.raport_id,
                typ_id: state.typ_id,
                cykl: state.cykl,
                data_od: null,
                data_do: null,
                wybor: checkedOption,
                wybor_dane: checkedOption === 3 ? null : carIds,
                warunki: conditions ? conditions : null,
                plik_id: fileId,
                email: state.email
            });
            onClose();
        }
    };

    const handleEmailSubmit = (emails) => {
        if (!isEdit) {
            setEmailsOpen(false);
            onSubmit && onSubmit({
                ...dataToSend,
                email: emails ? emails : []
            });
            onClose();
        }
        else {
            setState({
                ...state,
                email: emails
            });
            setEmailsOpen(false);
        }
    };

    const handleReportDetailsChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    };

    const handleRadioChange = (value) => {
        setCheckedOption(parseInt(value));
    };

    const handleSubmit25TypeIdCondition = (value) => {
        setConditions(value);
    };

    const handleSubmit26TypeIdCondition = (value) => {
        setConditions(value);
    };

    const handleSubmit30TypeIdCondition = (value) => {
        setConditions(value);
    };

    return (
        <AssignCarsOrGroupsDialog
            title={dialogTitle}
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            carIdArray={carList}
            gropuIdArray={groupList}
            option={checkedOption}
        >
            <ReportDetails
                autoEnable={autoEnable}
                reportName={state.nazwa ? state.nazwa : ""}
                reportFilename={state.nazwa_pliku}
                typeId={state.typ_id}
                cycle={state.cykl}
                startTime={state.startTime}
                endTime={state.endTime}
                reportConditions={conditions}
                onChange={handleReportDetailsChange}
                isEdit={isEdit}
                onEmailsEdit={() => setEmailsOpen(true)}
                checkedOption={checkedOption}
                onRadioChange={handleRadioChange}
                withCars
                isNew={isNew}
                onSubmit7TypeId={props.onFileSubmit}
                onSubmit25TypeId={handleSubmit25TypeIdCondition}
                onSubmit26TypeId={handleSubmit26TypeIdCondition}
                onSubmit30TypeId={handleSubmit30TypeIdCondition}

            />
            <EmailsDialog
                open={emailsOpen}
                onClose={() => setEmailsOpen(false)}
                onSubmit={handleEmailSubmit}
                inputEmails={state.email}
            />
        </AssignCarsOrGroupsDialog>
    );
};

const mapStateToProps = state => {
    return {
        fileId: state.reportReducer.fileId,
    };
};

ReportDetailsWithCars.propTypes = {
    title: PropTypes.string,
    report: PropTypes.object,
    open: PropTypes.bool,
    isEdit: PropTypes.bool,
    autoEnable: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    isNew: PropTypes.bool,
    typeId: PropTypes.number,
    onFileSubmit: PropTypes.func,
    fileId: PropTypes.number,
};

export default connect(mapStateToProps)(ReportDetailsWithCars);
